import { render, staticRenderFns } from "./CheckBoxes.vue?vue&type=template&id=5277db3c&"
import script from "./CheckBoxes.vue?vue&type=script&lang=js&"
export * from "./CheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxes.vue?vue&type=style&index=0&id=5277db3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports